import { Injectable } from "@angular/core";
import { Route, Router, UrlSegment, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { FeatureVisibilityControllerService } from "../services/feature-visibility-controller.service";

@Injectable({
    providedIn: "root",
})
export class FeatureCanLoadGuard  {
    constructor(
        private featureVisibilityControllerService: FeatureVisibilityControllerService,
        private router: Router,
    ) {}

    canLoad(
        route: Route,
        segments: UrlSegment[],
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (!this.featureVisibilityControllerService.isFeatureAllowed(route.path)) {
            this.router.navigate(["home"]);
            return false;
        }
        return true;
    }
}
